import { Stack, Typography } from "@mui/material";
import React from "react";
import { ReviewSection } from "../DeployWizard.styles";

const ReviewSummaryCard = ({ releaseName, ttlHours, useCaseLabel, memory }) => (
  <ReviewSection>
    <Typography variant="subtitle2" fontWeight={600}>Environment Summary</Typography>
    <Stack gap={1}>
      <SummaryRow label="Release Name" value={releaseName} />
      <SummaryRow label="Use Case" value={useCaseLabel} />
      <SummaryRow label="TTL" value={`${ttlHours} hours`} />
      {memory && <SummaryRow label="Memory" value={`${memory} Gi`} />}
    </Stack>
  </ReviewSection>
);

const SummaryRow = ({ label, value }) => (
  <Stack direction="row" justifyContent="space-between">
    <Typography variant="body2">{label}</Typography>
    <Typography variant="body2" fontWeight={500}>{value}</Typography>
  </Stack>
);

export default ReviewSummaryCard;
